export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  return `${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isLowPowerDevice() {
  if (typeof window === 'undefined') return false;
  return navigator.hardwareConcurrency < 6;
}

/** Dispositivo com CPU/RAM limitados — aviso no prejoin e adaptações mais agressivas. */
export function isWeakClientDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const cores = navigator.hardwareConcurrency ?? 8;
  const deviceMemory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  if (cores <= 4) return true;
  if (typeof deviceMemory === 'number' && deviceMemory < 4) return true;
  return false;
}
